import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BalanceHistoriesService } from '../balance-histories/balance-histories.service';
import { Router } from '@angular/router';
import { IBalanceHistoryDto } from 'src/app/models/backend/balance-history';
import { PagedListingComponentBase } from 'src/app/shared/components/paged-listing-component-base';
import { IPagedBalanceHistoryResultRequestDto, IPagedTransactionReportResultRequestDto, } from 'src/app/models/backend';
import { CreateBalanceHistoryComponent } from '../balance-histories/create-balance-history/create-balance-history.component';
import { IItemsHistoryDto } from 'src/app/models/backend/transaction-report';
import { TransactionReportService } from './transaction-report.service';
import { RetailersService } from '../retailers/retailers.service';
import { OrderStatus, UserRole } from 'src/app/models/enums';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { LoginService } from '../login/login.service';
import { environment } from 'src/environments/environment';
import { ProductService } from '../products/product.service';

@Component({
  selector: 'app-transaction-report',
  templateUrl: './transaction-report.component.html',
  styleUrls: ['./transaction-report.component.scss']
})
export class TransactionReportComponent extends PagedListingComponentBase<IItemsHistoryDto> {
  protected override delete(entity: IItemsHistoryDto): void {
    throw new Error('Method not implemented.');
  }
  readonly baseURL=environment.appNameUrl
  myModel: any;
  keyword: any = '';
  categorySortingTypes: any[] = [];
  selectedCategorySortingTypes: number | null = 2;
  retailPrice: number = 0
  discount: number = 0
  retailCost: number = 0
  pridProfit: number = 0
  Retailers: any
  ddlRetailer: any
  filterRetailer: any
  activeProducts:any;
  productId:any=0;
  boolCustom = false
  request: any = {
    skipCount: 0,
    maxResultCount: 100,
    isInvoledDeletedItems: false,
    // startDate: "2024-08-15",
    // endDate: "2024-08-23",
    // retailerId: 0,
    keyword: "",
    isTestMode: true,
    productId:this.productId
  };
  @Output("updated") updated = new EventEmitter<boolean>();
  loader = false;
  loader1 = false;
  startDate: Date = new Date();
  endDate: Date = new Date();
  retailerId: any

  isTestMode = localStorage.getItem('isTestMode')
  TestMode: any
  Role: any

  totalItemsCount = 0
  data: any
  activeRetailerId: any = localStorage.getItem('RetailerId')

  dialogConfig = new MatDialogConfig();
  Orderitems: IItemsHistoryDto[] = [];
  previousOrderNumber: string | null = null;
  rowColor: string = 'white-row'; // Start with white color
  isPreviousOrderNumberSame: boolean = false;

  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    private service: TransactionReportService,
    private retailerService: RetailersService,
    private productService:ProductService,
    public router: Router,
    public loginService:LoginService,
  ) {
    super();
    this.Role = localStorage.getItem("RoleType")
    this.getRetailers();
    if (this.isTestMode == "true") {
      this.TestMode = true
    }
    else {
      this.TestMode = false
    }
    const today = new Date().toISOString().split('T')[0]; // Get today's date
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 1);
    this.endDate = new Date();
    this.loadActiveProducts();
  }
  
  protected override async list(request: IPagedTransactionReportResultRequestDto, pageNumber: number) {
    this.loader = true
    if (localStorage.getItem("TestMode") == 'true') {
      this.request.isTestMode = true
    }
    else {
      this.request.isTestMode = false
    }
    if (this.Role == 4) {
      this.request.isTestMode = this.TestMode
      this.retailerId = this.activeRetailerId
    }
    if (this.retailerId > 0) {
      this.request.retailerId = this.retailerId
    }
    this.loader = true
    this.request.startDate = this.startDate
    this.request.endDate = this.endDate
    this.request.productId=this.productId
    console.log(this.request)
    await this.service.getTransactionReport(this.request).subscribe((res: any) => {
      this.Orderitems = res.resultDto.items.map(item=>({
        ...item,
        itemStatus:OrderStatus[item.itemStatus]
      }));
      this.retailPrice = res.retailPrice
      this.discount = res.discount
      this.retailCost = res.retailCost
      this.pridProfit = res.pridProfit
      this.totalItemsCount = res.resultDto.totalCount
      console.log('transaction report paging data',res.resultDto);
      this.showPaging(res.resultDto, pageNumber)
      this.loader = false
      console.log(res)
    })
  }

  changeActiveProduct(){
    console.log(this.productId);
  }
  onPageChanged(pageNumber: number) {

    this.request = {
      isInvoledDeletedItems: false,
      skipCount: (pageNumber - 1) * 100,
      maxResultCount: 100,
      keyword: "",
      isTestMode: false,
      productId:this.productId
    }
    if (localStorage.getItem("TestMode") == 'true') {
      this.request.isTestMode = true
    }
    else {
      this.request.isTestMode = false
    }
    if (this.Role == 4) {
      this.request.isTestMode = this.TestMode
    }
    this.list(this.request, pageNumber,)
    this.getDataPage(pageNumber);
  }

  loadActiveProducts(){
    this.productService.GetActiveProduct().subscribe
      ({
        next: (res: any) => {
          this.activeProducts = res
          this.loader = false
        },
        error: e => {
          if (e.error.message) {
            this.loader= false
          }
          else {
            this.loader = false
          }
        }
      })
  }

  Filter(keyword) {
    // this.loader1=true
    this.request = {
      keyword: keyword,
      isInvoledDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      startDate: this.startDate,
      endDate: this.endDate,
      isTestMode: true,
      retailerId: this.activeRetailerId,
      productId:this.productId
    }
    if (localStorage.getItem("TestMode") == 'true') {
      this.request.isTestMode = true
    }
    else {
      this.request.isTestMode = false
    }
    if (this.Role == UserRole.Retailer) {
      console.log()
      this.request.isTestMode = this.TestMode
    }
    if (this.retailerId > 0) {
      this.request.retailerId = this.retailerId
    }
    console.log(this.request)
    
    this.list(this.request, 1)
    // this.service.getTransactionReport(this.request).subscribe((res: any) => {
    //   console.log(res)
    //   this.Orderitems = res.resultDto.items;
    //   this.retailPrice=res.retailPrice
    //   this.discount= res.discount
    //   this.retailCost= res.retailCost
    //   this.pridProfit= this.pridProfit
    //   this.showPaging(res.resultDto, 1)
    // this.loader1=false
    // })
  }

  filterRetailers(filterValue) {
    this.loader = true
    this.Retailers = this.ddlRetailer
    console.log(filterValue.value)
    this.retailerId = filterValue.value
    this.loader = false
    //var filter
    // filter = this.Retailers.filter(m => m.fullName.toLowerCase().includes(filterValue.value.toLowerCase()));
    // // this.Retailers=[]
    // this.Retailers=filter
    // console.log(filter)
    // if(filterValue.value=="" || filterValue.value==null){
    //   this.getRetailers()
    // }
    // if(filter==""){
    //   return
    // }
    // return
  }
  getRetailers() {
    var request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      Keyword: ""
    }
    this.loader = true
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers = res.items
      this.ddlRetailer = res.items
      this.loader = false
    })
  }
  onSelectChange(selectedValue) {
    console.log(selectedValue.value)
    selectedValue = selectedValue.value
    const today = new Date();
    const dayOfWeek = today.getDay();
    const year = today.getFullYear();
    const month = today.getMonth();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    const mondayOfWeek = new Date(today.setDate(diff));
    this.boolCustom = false
    switch (selectedValue) {
      case '1': // Today
        this.startDate = new Date();
        this.endDate = new Date();
        break;
      case '2': // Yesterday
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        this.startDate = yesterday;
        this.endDate = yesterday;
        break;
      case '3': // This week
        this.startDate = mondayOfWeek; // Set start date to Monday
        const endOfWeek = new Date(mondayOfWeek); // Create a new Date for the end of the week
        endOfWeek.setDate(mondayOfWeek.getDate() + 6); // Set to Sunday
        this.endDate = endOfWeek; // Set end date
        console.log(this.endDate)
        break;

      case '4': // Last Week
        const lastMonday = new Date(mondayOfWeek);
        lastMonday.setDate(lastMonday.getDate() - 7);
        const lastSunday = new Date(mondayOfWeek);
        lastSunday.setDate(lastSunday.getDate() - 1);
        this.startDate = lastMonday;
        this.endDate = lastSunday;
        break;
      case '5': // This Month
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        this.startDate = firstDayOfMonth;
        this.endDate = lastDayOfMonth;
        break;
      case '6': // Last Month
        const firstDayOfLastMonth = new Date(year, month - 1, 1);
        const lastDayOfLastMonth = new Date(year, month, 0);
        this.startDate = firstDayOfLastMonth;
        this.endDate = lastDayOfLastMonth;
        break;
      case '7': // Custom 
        this.boolCustom = true
        this.startDate = null;
        this.endDate = null;
        break;

      default:
        this.startDate = null;
        this.endDate = null;
        break;
    }
  }

  exportData() {
    this.loader = true
    this.request.maxResultCount = this.totalItemsCount
    console.log(this.request)
    this.request.productId=this.productId
    this.service.getTransactionReport(this.request).subscribe((res: any) => {
      this.data = res.resultDto.items
      const selectedHeaders = 
      {transactionDate: 'Date', operator:'Product', retailerName:'Retailer', 
        retailPrice:'Retail Price', discountPercentage:'Discount(%)', 
        discountAmount:'Discount Amount', quantity:'Quantity', 
        retailCost:'Retail Cost', status:'Status', 
        orderNumber:'Order Number', primaryNumber:'Primary Number', 
        recharegedNumber:'Recharged Number'}
      this.exportToCSV(this.data, 'Transaction Report.csv',selectedHeaders);
      this.loader = false
    })
  }
  exportToCSV(data: any[], filename: string, headerMapping: { [key: string]: string }) {
    if (data.length === 0) {
      alert("No data found to export")
      return;
    }

    const dataKeys = Object.keys(data[0]);
  const invalidHeaders = Object.keys(headerMapping).filter(header => !dataKeys.includes(header));
  if (invalidHeaders.length) {
    console.error('Invalid headers in mapping:', invalidHeaders);
    return;
  }
  const customHeaders = Object.values(headerMapping);
  const csvRows = [];

  csvRows.push(customHeaders.join(','));
  for (const row of data) {
    csvRows.push(Object.keys(headerMapping)
      .map(key => JSON.stringify(row[key], (key, value) => value === null ? '' : value))
      .join(',')
    );
  }
  const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  saveAs(csvBlob, filename);
  }
  exportDataPDF() {
    debugger
    this.loader = true
    this.request.maxResultCount = this.totalItemsCount
    this.request.productId=this.productId
    this.service.getTransactionReport(this.request).subscribe((res: any) => {
      this.data = res.resultDto.items
      this.exportToPDF(this.data, 'Transaction Report.pdf');
      this.loader = false
    })
  }
  exportToPDF(data: any[], filename: string) {
    const doc = new jsPDF();

    if (data.length === 0) {
      doc.text('No data available', 14, 16);
      doc.save(filename);
      return;
    }

    const pdfHeaders = ['Date', 'Product Info', 'Retailer', 'Retail Price', 'Discount(%)', 'Discount Amount', 'Quantity', 'Retail Cost', 'Status', 'Order Number', 'Primary Number', 'Recharged Number']
    const tableData = data.map(row => [
      row.transactionDate,
      row.operator,
      row.retailerName,
      row.retailPrice,
      row.discountPercentage,
      row.discountAmount,
      row.quantity,
      row.retailCost,
      row.status,
      row.orderNumber,
      row.primaryNumber,
      row.recharegedNumber
    ]);

    doc.text('Transaction Report', 14, 16);

    (doc as any).autoTable({
      head: [pdfHeaders],
      body: tableData,
      startY: 22,
      styles: { fontSize: 7 },
    });

    doc.save(filename);
  }
  getRowClass(index: number): string {
    const currentOrderNumber = this.Orderitems[index].orderNumber.toString();
    
    if (this.previousOrderNumber === currentOrderNumber) {
      this.isPreviousOrderNumberSame = true;
      return this.rowColor;
    } else {
      this.isPreviousOrderNumberSame = false;
      this.rowColor = this.rowColor === 'white-row' ? 'gray-row' : 'white-row';
      this.previousOrderNumber = currentOrderNumber;
      return this.rowColor;
    }
  }
  PrintRecipt(ordernumber){
    const url=this.router.serializeUrl(
       this.router.createUrlTree([this.baseURL+`printrecipt/print/id${ordernumber}`])
      //this.router.createUrlTree([`/PridAppLive/printrecipt/id${ordernumber}`])
      // this.router.createUrlTree([`/printrecipt/id${ordernumber}`])

    )
    window.open(url,'_blank')
  }
  // logout() {
  //   this.loginService.logout();
  // }
}
